"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxIcon = exports.checkboxIconSvgData = void 0;
var answers_ui_libby_1 = require("@wix/answers-ui-libby");
var React = require("react");
exports.checkboxIconSvgData = "\n\t<svg width=\"13\" height=\"10\" viewBox=\"0 0 13 10\">\n\t\t<path d=\"M3.788 9.073l.71.72.712-.72 7.587-7.666L11.375 0l-6.86 6.962-3.092-3.128L0 5.24l3.788 3.833z\"></path>\n\t</svg>\n";
exports.CheckboxIcon = function () { return (React.createElement("span", { className: 'check-icon' },
    React.createElement(answers_ui_libby_1.Icon, { icon: exports.checkboxIconSvgData }))); };
//# sourceMappingURL=checkbox-icon.js.map